import { Component, OnInit } from '@angular/core';
import { UserService } from '../user/user.service';
import { interval } from "rxjs/observable/interval";
import { startWith } from "rxjs/operators";
import { Subscription } from 'rxjs/Rx';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../shared/shared.service';
import { Logger } from 'angular2-logger/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-wait-report',
  templateUrl: './wait-report.component.html',
  styleUrls: ['./wait-report.component.scss'],
  providers: [UserService]
})
export class WaitReportComponent implements OnInit {
  public filter: FormGroup; 
  public listWait: any;
  public roomsMsg : any;
  public dataHistorialRooms : any;
  public states: any;
  public title_toModal: string;
  public body_toModal: string;
  public dropdownStatus = [];
  public dropdownList2 = [];
  public selectedItems = [];
  public selectedItemsStatus = [];
  public dropdownSettings = {};
  public dropdownSettingsStatus = {};
  public shop_report_array: Array<any> = [];
  public status_report_array: Array<any> = [];

  public dataTable : any;

  public list_var_wait: any;

  // Observadores.
  private intervalSub: Subscription;
  private intervalSubByStatus: Subscription;
  constructor(
    private spinner: NgxSpinnerService, 
    private _sharedService: SharedService,
    private userService: UserService,
    private logger: Logger, 
    private fb: FormBuilder,
    public toastr: ToastsManager
    ) { 
      this.filter = this.fb.group({
        date_start_report: ['', Validators.required],
        date_end_report: ['', Validators.required],
        shop: [],
        tStatus: ['', Validators.required],
      });
    }

  ngOnInit() {
    let data = {
			auth_token: this._sharedService.getCookie("auth_token")
		};

    this.dropdownSettings = { 
      singleSelection: false,
      text: 'Seleccionar tienda',
      searchPlaceholderText: 'Buscar',
      selectAllText: 'Seleccionar todos',
      unSelectAllText: 'Deseleccionar todos',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };

    this.dropdownSettingsStatus = { 
      singleSelection: false,
      text: 'Seleccionar estado',
      searchPlaceholderText: 'Buscar',
      selectAllText: 'Seleccionar todos',
      unSelectAllText: 'Deseleccionar todos',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };

		this.userService.getShop(data).subscribe(
			data => {
				let valuei= 0;
				for (let i = 0; i < data.data.length; i++) {
					this.dropdownList2[i] = 
					{'id': data.data[i].id_shop, 'itemName':data.data[i].description};
					valuei = i;  
				}
			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);

    this.userService.getStatusPending(data).subscribe(
			data => {
				let valuei= 0;
				for (let i = 0; i < data.data.length; i++) {
					this.dropdownStatus[i] = 
					{'id': data.data[i].id_status, 'itemName':data.data[i].description};
					valuei = i;  
				}
			},
			error => { //server error
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		);

  }

  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }

  onFilter() {
    //this.load = true;
    this.spinner.show();

    if (this.filter.value.shop.length !== 0) {
      this.filter.value.shop.forEach(element => {
        this.shop_report_array.push(element.id);
      });
    }

    if (this.filter.value.tStatus.length !== 0) {
      this.filter.value.tStatus.forEach(element => {
        this.status_report_array.push(element.id);
      });
    }

    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      date_start: this.filter.value.date_start_report,
      date_end: this.filter.value.date_end_report,
      shop:this.shop_report_array,
      status:this.status_report_array
    };
    
    //this.filter.value.auth_token = this._sharedService.getCookie('auth_token');

    this.userService.getReportDataWait(data).subscribe(
      data => {
        this.listWait = data.data;
        this.dataTable = data.data;
        console.log(data.data);
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
      }
    );

    

    this.shop_report_array = [];
    this.status_report_array = [];
  }

  exportAsXLSX():void {
    this.userService.exportAsExcelFile(this.dataTable, 'reporte');
  }

  verConversacion(id) {
    if(id){
      this.spinner.show();

      let data = { 
        auth_token: this._sharedService.getCookie('auth_token'),
        room_id: id,
        // page: id_page
      };

      this.userService.getRoomMsgs(data).subscribe(
        data => {
          if (data.status) {

            //   if (data.data.last_page >= data.data.current_page) {
            // saving everything into "rooms"
            this.logger.log("received history:"); 
            this.logger.log(data);
            //console.log('Prueba de data2');
            //console.log(data.data);
            if(data.data) {
              if (!this.roomsMsg)
                this.roomsMsg = {};

              if (!this.roomsMsg.msgs) {
                this.roomsMsg.msgs = [];
              }

              if (this.roomsMsg.msgs.length === 0) {
                this.dataHistorialRooms = data.data.dataReport;
                this.roomsMsg.msgs = data.data.data;
              } else {
                this.roomsMsg.msgs = [];
                this.roomsMsg.msgs = data.data.data; 
                this.dataHistorialRooms = data.data.dataReport;
              }

              //this.load = false;
              this.states = {
                currentPage: this.roomsMsg.current_page = data.data.current_page,
                lastPage: this.roomsMsg.current_page = data.data.last_page
              };
            }
            //   }

          } else {
            //this.load = false;
            this.logger.log(data.message);
          }

          this.spinner.hide();

          this.title_toModal = "Conversación No. " + id;
          this.body_toModal = "Si hay información";
          $('#historialRooms').modal('toggle',{backdrop: false});
          $('#historialRooms').appendTo("body");

        },
        error => {
          console.log("Justo antes");
          this.logger.log(error);

        }
      );
    }
}

  verConversacion2(id) {
    this.spinner.show();

    let data = { 
      auth_token: this._sharedService.getCookie('auth_token'),
      id_room_pending: id,
      // page: id_page
    };

    this.userService.getRoomMsgsPending(data).subscribe(
      data => {
        //console.log("Este es data: ", data);
        if (data.status) {
          this.logger.log("received history:"); 
          this.logger.log(data);
          if(data.data) {

            if (!this.roomsMsg){
              this.roomsMsg = {};
            }

            if (!this.roomsMsg.msgs) {
              this.roomsMsg.msgs = [];
            }

            if (this.roomsMsg.msgs.length === 0) {
              //this.dataHistorialRooms = data.data.dataReport;
              this.roomsMsg.msgs = data.data;
            } else {
              this.roomsMsg.msgs = [];
              this.roomsMsg.msgs = data.data; 
              //this.dataHistorialRooms = data.data.dataReport;
            }


            //this.load = false;
            this.states = {
              currentPage: this.roomsMsg.current_page = data.data.current_page,
              lastPage: this.roomsMsg.current_page = data.data.last_page
            };
          }
          //   }

        } else {
          //this.load = false;
          this.logger.log(data.message);
        }

        this.spinner.hide();

        this.title_toModal = "Conversación No. " + id;
        this.body_toModal = "Si hay información";
        $('#historialRooms').modal('toggle',{backdrop: false});
        $('#historialRooms').appendTo("body");

      },
      error => {
        console.log("Justo antes");
        this.logger.log(error);

      }
    );
    
  }

  verVariables(id,session_id,created_at) {
    this.spinner.show();

    let data = { 
      auth_token: this._sharedService.getCookie('auth_token'),
      id_room_pending: id,
      session_id:session_id,
      created_at:created_at,
      // page: id_page
    };

    this.userService.getVariablesPending(data).subscribe(
      data => {
        this.spinner.hide();
        this.list_var_wait = data.data;
        if (data.message == 'failVariables') {
          this.toastr.error("No hay variables asociadas", 'Atención');
        } else {
          this.title_toModal = "Reporte de espera - Información del usuario No. " + id;
          this.body_toModal = "Si hay información";
          $('#waitReportModal').modal('toggle',{backdrop: false});
          $('#waitReportModal').appendTo("body");
        }
      },
      error => {
        this.logger.log(error);
      }
    );
    
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/wait-report/wait-report.component.ts